import { useConnectModal } from '@rainbow-me/rainbowkit'
import { useAccount, useDisconnect } from 'wagmi'

export function formatAddress(address) {
    if (!address) return ''
    return `${address.slice(0, 6)}...${address.slice(-4)}`
}

export function useWalletUI() {
    const { address, isConnected, connector } = useAccount()
    const { openConnectModal } = useConnectModal()
    const { disconnect } = useDisconnect()

    return {
        address,
        walletName: connector?.name || 'Wallet',
        isConnected: Boolean(isConnected && address),
        openConnectModal,
        disconnect,
    }
}

